export default class Timeline {
    /**
     * Constructor for the Timeline class
     * @param {string} timelineSelector - Selector for the timeline container
     */
    constructor(timelineSelector = '.side-timeline') {
        this.timeline = document.querySelector(timelineSelector)
        if (!this.timeline) {
            throw new Error(`Timeline element not found with selector: ${timelineSelector}`)
        }

        this.timelineHeight = this.timeline.querySelector('.line').offsetHeight
        this.indicators = gsap.utils.toArray('.side-timeline .stage-indicator')
        this.indicatorsPosition = this.indicators.map(
            (indicator) => indicator.offsetTop / this.timelineHeight
        )

        this.currentStage = null
        this.currentStageIndex = -1

        this.bus = this.timeline.querySelector('.bus')
        this.busPerson = this.timeline.querySelector('#bus-person')
        this.finalStopIcon = this.timeline.querySelector('.final-stop > svg')
        this.endIndicator = this.timeline.querySelector('.end-indicator')

        this.init()
    }

    /**
     * Initialize the timeline
     */
    init() {
        gsap.registerPlugin(ScrollTrigger)
        this.setupStageNavigation()
        this.scrollTrigger = this.createScrollTrigger()
    }

    /**
     * Setup click event listeners for stage navigation
     */
    setupStageNavigation() {
        this.indicators.forEach((indicator) => {
            indicator.addEventListener('click', (event) => {
                event.preventDefault()
                $(indicator).tooltip('hide')

                const stageSelectorInline = document.getElementById('stage-selector-inline')
                const targetStage = document.getElementById(
                    event.target.getAttribute('href').slice(1)
                )

                if (targetStage.classList.contains('current-stage')) {
                    gsap.to(window, {
                        duration: 2,
                        scrollTo: {
                            y: targetStage,
                            offsetY: -1,
                        },
                    })
                } else {
                    gsap.to(window, {
                        duration: 2,
                        scrollTo: {
                            y: stageSelectorInline,
                            offsetY: -1,
                        },
                        onComplete: () => {
                            stageSelectorInline
                                .querySelector(`a[href="#${targetStage.id}"]`)
                                .click()
                        },
                    })
                }
            })
        })
    }

    /**
     * Create the ScrollTrigger instance for the timeline
     * @returns {ScrollTrigger} The ScrollTrigger instance
     */
    createScrollTrigger() {
        return ScrollTrigger.create({
            trigger: '#main',
            scrub: 0.5,
            onRefresh: (self) => {
                this.currentStage = document.querySelector('.stage.current-stage')
                if (this.currentStage) {
                    this.currentStageIndex = this.currentStage.id.split('-').pop() - 1
                }
            },
            onUpdate: (self) => {
                gsap.set(this.bus, {
                    top: () => {
                        if (!this.currentStage || this.currentStageIndex < 0) {
                            return 0
                        }
                        if (this.currentStageIndex >= this.indicators.length - 1) {
                            let currentStagePosition =
                                this.indicatorsPosition[this.currentStageIndex]
                            let progressToMax = self.progress * (1 - currentStagePosition)
                            return `${(currentStagePosition + progressToMax) * 100}%`
                        }
                        const currentStagePosition = this.indicatorsPosition[this.currentStageIndex]
                        const nextStagePosition =
                            this.indicatorsPosition[this.currentStageIndex + 1]
                        const progressBetweenStages =
                            self.progress * (nextStagePosition - currentStagePosition)
                        return `${(currentStagePosition + progressBetweenStages) * 100}%`
                    },
                })

                const ending = this.currentStageIndex === this.indicators.length - 1
                gsap.set(this.busPerson, {
                    opacity: ending ? 1 : 0,
                })
                gsap.set(this.finalStopIcon, {
                    opacity: ending ? 0 : 1,
                })
                gsap.set(this.endIndicator, {
                    opacity: ending ? 1 : 0,
                })
            },
        })
    }
}
